export default {
  formId: 'createParameterForm', //'createParameterForm',
  formField: {
    llegadas_tarde: {
      name: 'llegadas_tarde',
      label: 'Minutos llegada tarde*',
      requiredErrorMsg: 'Minutos llegada tarde es requerido.',
    },
    salidas_tarde: {
      name: 'salidas_tarde',
      label: 'Minutos salida tarde*',
      requiredErrorMsg: 'Minutos salida tarde es requerido.',
    },
    salario_minimo: {
      name: 'salario_minimo',
      label: 'Salario minimo*',
      requiredErrorMsg: 'Salario minimo es requerido.',
    },
    auxilio_transporte: {
      name: 'auxilio_transporte',
      label: 'Auxilio transporte*',
      requiredErrorMsg: 'Auxilio transporte es requerido.',
    },
    interes_cesantias: {
      name: 'interes_cesantias',
      label: 'Intereses cesantias*',
      requiredErrorMsg: 'Intereses cesantias es requerido.',
    },
    year: {
      name: 'year',
      label: 'Año*',
      requiredErrorMsg: 'Año es requerido.',
    },
    horasSemanales: {
      name: 'horasSemanales',
      label: 'Horas semanales',
      requiredErrorMsg: 'Horas semanales es requerida.',
    },
    horasMensuales: {
      name: 'horasMensuales',
      label: 'Horas mensuales',
      requiredErrorMsg: 'Horas mensuales es requerida.',
    },
  },
};
